import { SET_WORKSPACE, UPDATE_CONFIGSTATUS } from "./types";

//Set Workspace
export const setWorkspace = (payload) => {
  return {
    type: SET_WORKSPACE,
    payload,
  };
};

export const updateConfigStatus = (payload) => {
  return {
    type: UPDATE_CONFIGSTATUS,
    payload,
  };
};
